function NovaPoshtaMain() { 
  const apiKey            = NP_API_KEY;
  const endpointNP        = 'https://api.novaposhta.ua/v2.0/json/';
  const country           = 'Ukraine';
  const provider          = 'Нова пошта';
  const quickIndices      = quickCityIndices.split(' ');
  const bodyNP            = document.getElementById('nova-poshta');
  const deliveryVariants  = document.getElementById('deliveryVariants');

  const deliveryTypes     = document.querySelectorAll('input[type="radio"][name="id"]');
  let deliveryType        = deliveryTypes[0].getAttribute('data-type');
  let isDelivery          = false;
  // Wraps
  const wrapWarehouse     = document.querySelector('.warehouse-wrap');
  const wrapAddresses     = document.querySelector('.address-wrap');
  // Inputs
  const inputCity         = document.getElementById('city-search');
  const inputWarehouse    = document.getElementById('warehouse-search');
  const inputStreet       = document.getElementById('address-street');
  const inputBuild        = document.getElementById('address-build');
  const inputFlat         = document.getElementById('address-flat');
  const inputFields       = document.querySelectorAll('.form-group input');
  const filterFields      = document.querySelectorAll('.dropdown-filter');

  const buttonShipping    = document.querySelector('[data-name="shipping"]');  
  const cartDraver        = document.querySelector('.qsc2-drawer');
  const cityErrorEl       = document.querySelector('.city-wrap .input-error'); 
  const warehouseErrorEl  = document.querySelector('.warehouse-wrap .input-error');
  const streetErrorEl     = document.querySelector('.address-wrap .input-error');
  const clearCity         = document.querySelector(".city-wrap .clear");
  const clearWarehouse    = document.querySelector(".warehouse-wrap .clear");
  const clearStreet       = document.querySelector(".form-street .clear");
  const cartUrl           = deliveryVariants.getAttribute('data-carturl');
  const properties        = {_provider: provider, _country: country};

  /* --------------------------------------------------------------------------
     АТРИБУТЫ ДОСТАВКИ И ЗАКАЗ.

     Виджет складывает всё, что знает о доставке, в атрибуты корзины
     (updateCartDeliveryAttr) и дублирует их в cart-permalink. Оттуда они
     попадают в заказ и вываливаются в админке («Additional details») и в
     комментарии менеджера в CRM — два десятка строк на каждый заказ.

     Приложению nova-poshta-public-app они не нужны: ТТН строится из адреса
     доставки заказа (shippingAddress.city + address1, номер отделения оттуда
     достаёт get_warehouse_number_v2), а customAttributes оно читает только
     ради способа оплаты.

       CART_ATTRS  — что остаётся в атрибутах корзины, пока покупатель на сайте.
                     _delivery_type нужен самому виджету: по нему при
                     перезагрузке восстанавливается вкладка «Відділення/Кур'єр».
       ORDER_ATTRS — что уезжает в permalink, то есть в заказ. Пусто = ничего.

     Всё, чего нет в CART_ATTRS, отправляется в корзину как null — Shopify такой
     атрибут удаляет, поэтому старые корзины тоже дочищаются.
     -------------------------------------------------------------------------- */
  const CART_ATTRS  = ['_delivery_type'];
  const ORDER_ATTRS = [];

  function cartAttrPayload(data) {
    const payload = {};
    for (var key in data) {
      payload[key] = (CART_ATTRS.indexOf(key) !== -1) ? data[key] : null;
    }
    return payload;
  }

  function orderAttrPairs(data) {
    const pairs = [];
    ORDER_ATTRS.forEach(function (key) {
      if (data[key]) pairs.push('attributes[' + key + ']=' + data[key]);
    });
    return pairs;
  }

  /* Перед уходом на чекаут корзина дочищается полностью: иначе то, что лежит
     в её атрибутах, перетечёт в заказ мимо permalink. */
  function clearCartDeliveryAttr() {
    const cleared = {};
    for (var key in properties) cleared[key] = null;
    CART_ATTRS.forEach(function (key) { cleared[key] = null; });
    return fetch('/cart/update.js', {
      method: 'POST',
      body: JSON.stringify({ attributes: cleared }),
      credentials: 'same-origin',
      cache: 'no-cache',
      headers: { 'Content-Type': 'application/json' }
    });
  }

  /* Уход на чекаут: сначала чистим корзину, потом редирект. Ошибка чистки не
     должна запирать покупателя в корзине — уходим в любом случае. */
  function goToCheckout(url) {
    const go = function () { window.location.href = url; };
    clearCartDeliveryAttr().then(go, go);
  }

  /* ==========================================================================
     INTL — МІЖНАРОДНА ДОСТАВКА (Nova Post за кордоном), вкладка data-type="intl".

     Країна обирається зі списку (.intl-wrap у сниппеті). Далі два режими:
       division — відділення/поштомат Nova Post через офіційний віджет
                  https://integration-widget.novapost.com/sdk.min.js
                  (попап з картою; API-ключ у браузері не потрібен — віджет
                  ходить через власний проксі Nova Post);
       address  — адресна доставка, поля вводяться вручну.

     У чекаут Shopify адреса йде так само, як для України — через
     cart-permalink `checkout[shipping_address][...]`, тільки country = країна
     зі списку (англійська назва з data-name, як її знає Shopify).

     Стан (країна, режим, обране відділення, поля адреси) живе в sessionStorage
     'np_intl': тема перемальовує cart-drawer при кожній зміні кошика, і віджет
     монтується заново.
     ========================================================================== */
  const wrapIntl         = document.querySelector('.intl-wrap');
  const intlCountry      = document.getElementById('intl-country');
  const intlDivision     = document.getElementById('intl-division');
  const intlCity         = document.getElementById('intl-city');
  const intlStreet       = document.getElementById('intl-street');
  const intlFlat         = document.getElementById('intl-flat');
  const intlZip          = document.getElementById('intl-zip');
  const intlModes        = document.querySelectorAll('input[name="intl_mode"]');
  const intlDivisionWrap = document.querySelector('.intl-division-wrap');
  const intlAddressWrap  = document.querySelector('.intl-address-wrap');
  const intlDivisionClear = intlDivision ? intlDivision.closest('.form-group').querySelector('.clear') : null;
  const INTL_SDK         = 'https://integration-widget.novapost.com/sdk.min.js';
  const methodIntl       = (typeof window.methodIntl === 'string' && window.methodIntl) ? window.methodIntl : 'International delivery';

  const intl = { country: '', countryName: '', mode: 'division', division: null };
  let intlWidget = null;
  window.npIntlReady = false;

  function intlErr(el, msg) {
    const group = el && el.closest('.form-group');
    const box   = group && group.querySelector('.input-error');
    if (box) box.innerHTML = msg || '';
  }

  function intlDivisionLabel(d) {
    return [d.name, d.displayAddress].filter(Boolean).join(' — ');
  }

  function intlSave() {
    try {
      sessionStorage.setItem('np_intl', JSON.stringify({
        country: intl.country, mode: intl.mode, division: intl.division,
        city: intlCity.value, street: intlStreet.value, flat: intlFlat.value, zip: intlZip.value
      }));
    } catch (e) {}
  }

  function intlRestore() {
    let d = null;
    try { d = JSON.parse(sessionStorage.getItem('np_intl') || 'null'); } catch (e) {}
    if (!d) return;
    intlCountry.value = d.country || '';
    intl.country      = intlCountry.value;
    intl.countryName  = intl.country ? (intlCountry.options[intlCountry.selectedIndex].getAttribute('data-name') || '') : '';
    intl.mode         = (d.mode === 'address') ? 'address' : 'division';
    intlModes.forEach(function (r) { r.checked = (r.value === intl.mode); });
    intl.division     = d.division || null;
    intlDivision.value = intl.division ? intlDivisionLabel(intl.division) : '';
    if (intlDivisionClear) intlDivisionClear.classList.toggle('d-none', !intl.division);
    intlCity.value   = d.city   || '';
    intlStreet.value = d.street || '';
    intlFlat.value   = d.flat   || '';
    intlZip.value    = d.zip    || '';
  }

  function intlAddressFilled() {
    return !!(intlCity.value.trim() && intlStreet.value.trim() && intlZip.value.trim());
  }

  function intlValid() {
    if (!intl.country) return false;
    return (intl.mode === 'division') ? !!intl.division : intlAddressFilled();
  }

  function intlShowErrors() {
    intlErr(intlCountry, intl.country ? '' : wrapIntl.getAttribute('data-err-country'));
    if (intl.mode === 'division') intlErr(intlDivision, intl.division ? '' : wrapIntl.getAttribute('data-err-division'));
    else                          intlErr(intlZip, intlAddressFilled() ? '' : wrapIntl.getAttribute('data-err-address'));
  }

  /* Показ потрібного режиму + стан кнопки чекауту. Викликається на кожну зміну. */
  function intlSync() {
    intlDivisionWrap.classList.toggle('d-none', intl.mode !== 'division');
    intlAddressWrap.classList.toggle('d-none', intl.mode !== 'address');
    const ok = intlValid();
    window.npIntlReady = ok;
    if (ok) {
      checkoutButton.disabled = false;
      checkoutButton.classList.remove('disabled');
      checkoutButtonWrapper.classList.remove('tool');
      intlErr(intlCountry, ''); intlErr(intlDivision, ''); intlErr(intlZip, '');
    } else {
      checkoutButton.disabled = true;
      checkoutButton.classList.add('disabled');
      checkoutButtonWrapper.classList.add('tool');
    }
    intlSave();
  }

  function intlEnter() {
    if (!wrapIntl) return;
    bodyNP.classList.add('np-intl');
    wrapIntl.classList.remove('d-none');
    wrapWarehouse.classList.add('d-none');
    wrapAddresses.classList.add('d-none');
    intlRestore();
    intlSync();
  }

  function intlLeave() {
    if (!wrapIntl) return;
    bodyNP.classList.remove('np-intl');
    wrapIntl.classList.add('d-none');
    window.npIntlReady = false;
  }

  function intlLoadSdk(cb) {
    if (window.NovaPostWidget) return cb();
    let tag = document.querySelector('script[data-np-intl-sdk]');
    if (!tag) {
      tag = document.createElement('script');
      tag.src = INTL_SDK;
      tag.async = true;
      tag.setAttribute('data-np-intl-sdk', '1');
      document.head.appendChild(tag);
    }
    tag.addEventListener('load', cb);
  }

  function intlCreateWidget() {
    /* після перемальовки drawer попередній інстанс тримає iframe/попап у body — знести */
    if (window.npIntlWidget) { try { window.npIntlWidget.destroy(); } catch (e) {} window.npIntlWidget = null; }
    const host = document.getElementById('intl-widget-host');
    if (!host) return null;
    const w = new NovaPostWidget.NovaPostWidget({
      container:    host,
      locale:       'uk',
      variant:      'widget',
      viewMode:     'popup',
      shipmentRole: 'recipient',
      theme:        'light',
      country:      intl.country || null,
      onSelect: function (d) {
        const parts = d.addressParts || {};
        intl.division = {
          id: d.id, name: d.name, displayAddress: d.displayAddress || '',
          city: parts.city || '', street: parts.street || '', postCode: parts.postCode || '', region: parts.region || ''
        };
        intlDivision.value = intlDivisionLabel(intl.division);
        if (intlDivisionClear) intlDivisionClear.classList.remove('d-none');
        intlSync();
        try { w.hide(); } catch (e) {}
      },
      onClear: function () {
        intl.division = null;
        intlDivision.value = '';
        if (intlDivisionClear) intlDivisionClear.classList.add('d-none');
        intlSync();
      },
      onError: function (err) { console.log('np intl widget:', err && err.message); }
    });
    window.npIntlWidget = w;
    return w;
  }

  function intlOpenWidget() {
    if (!intl.country) { intlErr(intlCountry, wrapIntl.getAttribute('data-err-country')); return; }
    intlLoadSdk(function () {
      if (!intlWidget) intlWidget = intlCreateWidget();
      if (!intlWidget) return;
      try { intlWidget.updateParams({ country: intl.country, locale: 'uk' }); } catch (e) {}
      intlWidget.show();
      /* Попап SDK висить у body, поза cart-drawer. Тема закриває drawer по кліку
         поза .cart-drawer__inner (слухач на document) — гасимо спливання на
         оверлеї попапу. Фаза bubble: власні обробники SDK на оверлеї та його
         нащадках спрацьовують, до document подія не доходить. */
      document.querySelectorAll('[data-nova-post-widget-popup-overlay]').forEach(function (ov) {
        if (ov.getAttribute('data-np-guard')) return;
        ov.setAttribute('data-np-guard', '1');
        ['click', 'mousedown', 'touchstart', 'pointerdown'].forEach(function (type) {
          ov.addEventListener(type, function (e) { e.stopPropagation(); });
        });
      });
    });
  }

  function intlAddress() {
    const a = { country: intl.countryName, city: '', address1: '', address2: '', zip: '' };
    if (intl.mode === 'division') {
      const d = intl.division || {};
      a.city     = d.city || '';
      a.address1 = 'Nova Post: ' + (d.name || '');
      a.address2 = d.street || d.displayAddress || '';
      a.zip      = d.postCode || '';
    } else {
      a.city     = intlCity.value.trim();
      a.address1 = intlStreet.value.trim();
      a.address2 = intlFlat.value.trim();
      a.zip      = intlZip.value.trim();
    }
    return a;
  }

  /* Той самий cart-permalink, що й для України (див. обробники кнопки нижче). */
  function intlCheckout() {
    const address = intlAddress();
    fetch(`${cartUrl}.json`).then(response => response.json()).then(data => {
      const pairs = [];
      const path = data.items.map(item => `${item.variant_id}:${item.quantity}`).join(',');
      orderAttrPairs(properties).forEach(function (pair) { pairs.push(pair); });
      for (var key in address) {
        if (!address[key]) continue;
        pairs.push(`checkout[shipping_address][${key}]=${encodeURIComponent(address[key])}`);
      }
      let query = pairs.join('&');
      if (data.note) query += `&note=${data.note}`;
      goToCheckout(`${cartUrl}/${path}?${query}`);
    }).catch(function () {
      checkoutButton.disabled = false;
      checkoutButton.classList.remove('disabled');
    });
  }

  if (wrapIntl) {
    intlCountry.addEventListener('change', function () {
      intl.country     = this.value;
      intl.countryName = this.value ? (this.options[this.selectedIndex].getAttribute('data-name') || '') : '';
      intl.division    = null;
      intlDivision.value = '';
      if (intlDivisionClear) intlDivisionClear.classList.add('d-none');
      if (intlWidget) { try { intlWidget.updateParams({ country: intl.country || null }); } catch (e) {} }
      intlSync();
    });
    intlModes.forEach(function (r) {
      r.addEventListener('change', function () { intl.mode = this.value; intlSync(); });
    });
    intlDivision.addEventListener('click', intlOpenWidget);
    if (intlDivisionClear) {
      intlDivisionClear.addEventListener('click', function () {
        intl.division = null;
        intlDivision.value = '';
        this.classList.add('d-none');
        intlSync();
      });
    }
    [intlCity, intlStreet, intlFlat, intlZip].forEach(function (el) { el.addEventListener('input', intlSync); });
  }

  let dataCities, dataWarehouses, dataStreet, addressCity, addressZip, addressStreet, addressBuild, addressFlat, cityData, warehouseData;
  wrapWarehouse.classList.add('d-none');    
  wrapAddresses.classList.add('d-none'); 
  checkoutButton.classList.add('disabled');
  checkoutButtonWrapper.classList.add('tool');
  checkoutButton.disabled = true;
  /*== shipping notifications ==*/
  function btnHover() {  
    checkoutButtonWrapper.addEventListener("mouseover", (event) => {
      if(checkoutButtonWrapper.classList.contains('tool')) {
        buttonShipping.classList.add('button-hover');
      }
    })
    checkoutButtonWrapper.addEventListener("mouseout", (event) => {        
      if(checkoutButtonWrapper.classList.contains('tool')) {
        buttonShipping.classList.remove('button-hover');
      }
    })
  }
  /*== update cart note  ==*/
  async function updateCartNote() {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({note: "null"}),
        credentials: 'same-origin',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.json();
    } catch (error) {
      throw error;
    }
  }
  if(pageType == 'sidebar') btnHover();

  /*== Error API ==*/
  function errorAPI() {
    document.querySelector('.checkout-button-wrap').classList.remove('tool');
    console.log('error');
    /*== check selected delivery type ==*/
    fetch(`${cartUrl}.json`).then(response => response.json()).then(data => {

      wrapWarehouse.classList.add('d-none');    
      wrapAddresses.classList.add('d-none');
      //alert('1');

      if (data.attributes._delivery_type) {
        isDelivery = true;
        deliveryVariants.setAttribute('data-variant', data.attributes._delivery_type);
        if(cartDraver) cartDraver.setAttribute('data-delivery', data.attributes._delivery_type);
        document.querySelector('input[type="radio"][name="id"][data-type='+data.attributes._delivery_type+']').checked=true;
        deliveryType = data.attributes._delivery_type;
        
        if(deliveryType == 'courier') {

          filterExclusion = '-1';
          wrapAddresses.classList.remove('d-none');
          properties._delivery_method  = methodCourier;
          checkoutButton.disabled = false;
          checkoutButtonWrapper.classList.remove('tool');
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = methodCourier;

        } else if (deliveryType == 'intl') {

          filterExclusion = '0';
          properties._delivery_method = methodIntl;
          intlEnter();

        } else {

          filterExclusion = '0';
          wrapWarehouse.classList.remove('d-none');
          properties._delivery_type = deliveryType;
          properties._delivery_method = methodBranch;

        }
      }    
      if (!isDelivery) {
        if(cartDraver) cartDraver.setAttribute('data-delivery', deliveryType);
        wrapWarehouse.classList.remove('d-none');
        properties._delivery_type = deliveryType;
        properties._delivery_method = methodBranch;        
        filterExclusion = '0';     
      }
      
      properties._delivery_courier_address              = null;
      properties._delivery_street                       = null;
      properties._delivery_house                        = null;
      properties._delivery_flat                         = null;
      properties._delivery_street_Ref                   = null;
      properties._delivery_city                         = null;
      properties._delivery_city_Area                    = null;
      properties._delivery_city_Ref                     = null;
      properties._delivery_warehouse                    = null;
      properties._delivery_warehouse_zip                = null;
      properties._delivery_warehouse_name               = null;
      properties._delivery_warehouse_address            = null;
      properties._delivery_warehouse_CityRef            = null;
      properties._delivery_warehouse_Number             = null;
      properties._delivery_warehouse_Ref                = null;
      properties._delivery_warehouse_SettlementRef      = null;
      properties._delivery_warehouse_TypeOfWarehouse    = null;

      updateCartDeliveryAttr(properties);
      
    
        //updateCartNote();

    }) 
    /*== check changes delivery type ==*/
    deliveryTypes.forEach(function(el){
      el.addEventListener("change", function(){
        deliveryType = this.getAttribute('data-type');
        wrapWarehouse.classList.add('d-none');    
        wrapAddresses.classList.add('d-none');
        inputFields.forEach(function(e){ e.value = '';})
        cityErrorEl.innerHTML = '';
        warehouseErrorEl.innerHTML = '';
        streetErrorEl.innerHTML = '';
        

        properties._delivery_type = deliveryType;
        if(cartDraver) cartDraver.setAttribute('data-delivery', deliveryType);
        intlLeave();
        if (deliveryType == 'branch') {
          properties._delivery_method = methodBranch;
          wrapWarehouse.classList.remove('d-none');
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = titleDelivery;
        } else if (deliveryType == 'intl') {
          properties._delivery_method = methodIntl;
          intlEnter();
        } else {
          properties._delivery_method = methodCourier;
          wrapAddresses.classList.remove('d-none');
          checkoutButton.classList.remove('disabled');
          checkoutButton.disabled = false;
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = methodCourier;
        }
        properties._delivery_courier_address              = null;
        properties._delivery_street                       = null;
        properties._delivery_house                        = null;
        properties._delivery_flat                         = null;
        properties._delivery_street_Ref                   = null;
        properties._delivery_city                         = null;
        properties._delivery_city_Area                    = null;
        properties._delivery_city_Ref                     = null;
        properties._delivery_warehouse                    = null;
        properties._delivery_warehouse_zip                = null;
        properties._delivery_warehouse_name               = null;
        properties._delivery_warehouse_address            = null;
        properties._delivery_warehouse_CityRef            = null;
        properties._delivery_warehouse_Number             = null;
        properties._delivery_warehouse_Ref                = null;
        properties._delivery_warehouse_SettlementRef      = null;
        properties._delivery_warehouse_TypeOfWarehouse    = null;
        updateCartDeliveryAttr(properties).then(function() {/*console.log(cart)*/}).catch(alert);     
      })
    })
    /*== update cart attribute  ==*/
    async function updateCartDeliveryAttr(data) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({ attributes: cartAttrPayload(data)}),
        credentials: 'same-origin',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.json();
    } catch (error) {
      throw error;
    }
    }
    checkoutButton.addEventListener('click', async function(e) {

      let shouldDisable = true;	
      if (shouldDisable) this.classList.add('disabled');
      
      e.preventDefault();
      this.disabled = true;
      /* INTL: своя валідація і свій permalink, українська логіка нижче не потрібна */
      if (deliveryType == 'intl') {
        if (!intlValid()) {
          intlShowErrors();
          this.disabled = false;
          this.classList.remove('disabled');
          return;
        }
        intlCheckout();
        return;
      } 
      
      
      addressStreet = addressCity = addressWarehouse = false;
      if(inputStreet.value) addressStreet = 'вул.'+inputStreet.value; //(addressStreet)?addressStreet:'';
      if(inputBuild.value) addressStreet = addressStreet +' буд.'+inputBuild.value;
      if(inputFlat.value) addressStreet = addressStreet +' кв.'+inputFlat.value;
      if(inputCity.value) addressCity = inputCity.value; //(addressCity)?addressCity:'';
      if(inputWarehouse.value) addressWarehouse = inputWarehouse.value;      
      addressZip = '12345';

      properties._delivery_courier_address              = (addressStreet != false ) ? addressStreet : null;
      properties._delivery_city                         = (addressCity != false ) ? addressCity : null;
      properties._delivery_warehouse_zip                = addressZip;
      properties._delivery_warehouse_Number             = (addressWarehouse != false ) ? addressWarehouse : null;

      updateCartDeliveryAttr(properties);   

      let addr_delivery_courier_address              = (addressStreet != false ) ? addressStreet : '';
      let addr_delivery_city                         = (addressCity != false ) ? addressCity : '';
      let addr_delivery_warehouse_Number             = (addressWarehouse != false ) ? addressWarehouse : '';

      const address = ({
        /* addr_delivery_warehouse_Number — это inputWarehouse.value, то есть уже
           полное название отделения. Хардкод-префикс «відділення/поштомат»
           давал дубль вида «відділення/поштомат Відділення №30: …». */
        address1: (deliveryType == 'branch') ? addr_delivery_warehouse_Number : addr_delivery_courier_address+' ('+methodCourier+')',
        zip: addressZip, 
        city: addr_delivery_city,
        country: country
      });
      
      setTimeout( function() {
      fetch(`${cartUrl}.json`).then(response => response.json()).then(data => {
          const pairs = [];
          
          const path = data.items.map(item => {
            return `${item.variant_id}:${item.quantity}`;
          }).join(',');

          orderAttrPairs(properties).forEach(function (pair) { pairs.push(pair); });

          for (var key in address) {
            const value = address[key];

            if (!value) continue;

            const pair = `checkout[shipping_address][${key}]=${address[key]}`;

            pairs.push(pair);
          }

          let query;
          let url;
          if (data.note && data.note != null) {
          query = pairs.join('&') + `&note=${data.note}`;
          url = `${cartUrl}/${path}?${query}`;
          } else {
          query = pairs.join('&');  
          url = `${cartUrl}/${path}?${query}`;
          }

          
          goToCheckout(url);

        })
        
      
      
      },200); 
        
    });
  }

  /*== Request API ==*/
  async function reqAPI(data) {

    console.log('data-',JSON.stringify(data)); 
    
    try {
      const response = await fetch(endpointNP, {
        method: 'POST',
        body: JSON.stringify(data),
        credentials: 'same-origin',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.json();      
    } 
    catch (error) {
      //throw error;
      console.log('error');
      console.log('data-',JSON.stringify(data)); 
       
    }
  } 

reqAPI({"apiKey": apiKey,"modelName": "AddressGeneral","calledMethod": "searchSettlements","methodProperties": {"CityName" : quickIndices[0],"Limit" : "150","Page" : "1"}})
.then(res => { 
  
  console.log(res.success);

  if (res.success) {

    /*== check selected delivery type ==*/
    fetch(`${cartUrl}.json`).then(response => response.json()).then(data => {

      wrapWarehouse.classList.add('d-none');    
      wrapAddresses.classList.add('d-none');
      //alert('1');

      if (data.attributes._delivery_type) {
        isDelivery = true;
        deliveryVariants.setAttribute('data-variant', data.attributes._delivery_type);
        if(cartDraver) cartDraver.setAttribute('data-delivery', data.attributes._delivery_type);
        document.querySelector('input[type="radio"][name="id"][data-type='+data.attributes._delivery_type+']').checked=true;
        deliveryType = data.attributes._delivery_type;
        
        if(deliveryType == 'courier') {

          filterExclusion = '-1';
          wrapAddresses.classList.remove('d-none');
          properties._delivery_method  = methodCourier;
          checkoutButton.disabled = false;
          checkoutButtonWrapper.classList.remove('tool');
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = methodCourier;

        } else if (deliveryType == 'intl') {

          filterExclusion = '0';
          properties._delivery_method = methodIntl;
          intlEnter();

        } else {

          filterExclusion = '0';
          wrapWarehouse.classList.remove('d-none');
          properties._delivery_type = deliveryType;
          properties._delivery_method = methodBranch;

        }
      }    
      if (!isDelivery) {
        if(cartDraver) cartDraver.setAttribute('data-delivery', deliveryType);
        wrapWarehouse.classList.remove('d-none');
        properties._delivery_type = deliveryType;
        properties._delivery_method = methodBranch;        
        filterExclusion = '0';     
      }
      
      properties._delivery_courier_address              = null;
      properties._delivery_street                       = null;
      properties._delivery_house                        = null;
      properties._delivery_flat                         = null;
      properties._delivery_street_Ref                   = null;
      properties._delivery_city                         = null;
      properties._delivery_city_Area                    = null;
      properties._delivery_city_Ref                     = null;
      properties._delivery_warehouse                    = null;
      properties._delivery_warehouse_zip                = null;
      properties._delivery_warehouse_name               = null;
      properties._delivery_warehouse_address            = null;
      properties._delivery_warehouse_CityRef            = null;
      properties._delivery_warehouse_Number             = null;
      properties._delivery_warehouse_Ref                = null;
      properties._delivery_warehouse_SettlementRef      = null;
      properties._delivery_warehouse_TypeOfWarehouse    = null;

      updateCartDeliveryAttr(properties);   
      
        //updateCartNote();
    }) 
    /*== check changes delivery type ==*/
    deliveryTypes.forEach(function(el){
      el.addEventListener("change", function(){
        deliveryType = this.getAttribute('data-type');
        wrapWarehouse.classList.add('d-none');    
        wrapAddresses.classList.add('d-none');
        checkoutButtonWrapper.classList.add('tool');
        inputFields.forEach(function(e){ e.value = '';})
        cityErrorEl.innerHTML = '';
        warehouseErrorEl.innerHTML = '';
        streetErrorEl.innerHTML = '';
        filterFields.forEach(function(f){ 
          while(f.firstChild){ filter.removeChild(filter.firstChild);}
        });

        properties._delivery_type = deliveryType;
        if(cartDraver) cartDraver.setAttribute('data-delivery', deliveryType);
        intlLeave();
        if (deliveryType == 'branch') {
          properties._delivery_method = methodBranch;         
          filterExclusion = '0';         
          wrapWarehouse.classList.remove('d-none');
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = titleDelivery;
        } else if (deliveryType == 'intl') {
          properties._delivery_method = methodIntl;
          intlEnter();
        } else {
          properties._delivery_method = methodCourier;        
          filterExclusion = '-1';         
          wrapAddresses.classList.remove('d-none');
          checkoutButton.classList.remove('disabled');
          checkoutButtonWrapper.classList.remove('tool');
          checkoutButton.disabled = false;
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = methodCourier;
        }
        properties._delivery_courier_address              = null;
        properties._delivery_street                       = null;
        properties._delivery_house                        = null;
        properties._delivery_flat                         = null;
        properties._delivery_street_Ref                   = null;
        properties._delivery_city                         = null;
        properties._delivery_city_Area                    = null;
        properties._delivery_city_Ref                     = null;
        properties._delivery_warehouse                    = null;
        properties._delivery_warehouse_zip                = null;
        properties._delivery_warehouse_name               = null;
        properties._delivery_warehouse_address            = null;
        properties._delivery_warehouse_CityRef            = null;
        properties._delivery_warehouse_Number             = null;
        properties._delivery_warehouse_Ref                = null;
        properties._delivery_warehouse_SettlementRef      = null;
        properties._delivery_warehouse_TypeOfWarehouse    = null;
        updateCartDeliveryAttr(properties).then(function() {/*console.log(cart)*/}).catch(alert);     
      })
    })
    /*== update cart attribute  ==*/
    async function updateCartDeliveryAttr(data) {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        body: JSON.stringify({ attributes: cartAttrPayload(data)}),
        credentials: 'same-origin',
        cache: 'no-cache',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      return response.json();
    } catch (error) {
      throw error;
    }
    }
    /*== hover on checkout button ==*/
    if(pageType == 'sidebar') {
      checkoutButton.addEventListener("mouseover", () => {    
          buttonShipping.classList.add('button-checkout-hover');
      })
      checkoutButton.addEventListener("mouseout", () => {     
          buttonShipping.classList.remove('button-checkout-hover');      
      })
    }
    /*== text input clear ==*/
    document.querySelectorAll(".clear").forEach(function(el, index){
        el.addEventListener('click', function() {
          document.querySelectorAll(".form-group input")[index].value = '';
          document.querySelectorAll(".form-group input")[index].readOnly = false;
          if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = titleDelivery;
          document.querySelectorAll(".form-group input")[index].focus();
          this.classList.add('d-none');
          if(index == 0) {
            document.querySelectorAll(".form-group").forEach(function(el) {
              el.querySelector('input').value = '';
              el.querySelector('.clear') ? el.querySelector('.clear').classList.add('d-none') : null;
              el.querySelector("input").readOnly = false;
            })
          }
          if (deliveryType == 'branch')  checkoutButtonWrapper.classList.add('tool');
          filterFields.forEach(function(f){clearList(f)});
          bodyNP.classList.remove('filter-active');
          warehouseErrorEl.innerHTML = '';
          cityErrorEl.innerHTML = ''; 
          streetErrorEl.innerHTML = '';      
      });
    })
    /*== remove filter result list ==*/
    function clearList(filter) {
      while(filter.firstChild){filter.removeChild(filter.firstChild)}
    }  
    function pointPrefix(data) {
      switch (data) {  
        case 'Postomat':
        pointType = 'Поштомат';
          break;
        case 'Branch':
        pointType = 'Відділення';
          break;      
        default:
        pointType = data;
          break;
      }
      return pointType;
    }
    function stripslashes_n(str) {
      if (str == null) return '';
      return str.replace(/'/g,`ʹ`);
    }   
    /*== search city  ==*/
    function searchCity() { 
      let linkClass = '';        
      let filter = document.querySelector('#city_filter');        
      let dataQuickCity;
      let quickOutput = '';
      let output_prev = 0;
      let cityReqSeq = 0; /* newest keystroke id - stale responses must not render */
      var cityWrap = filter.closest('.city-wrap');
      /* Synchronously toggle the full-screen panel class (same reason as in the
         warehouse block) so the city list never flashes its small default state
         before the overlay stretches it. */
      function openCityPanel()  { if (pageType == 'sidebar' && cityWrap) cityWrap.classList.add('np-list-open'); }
      function closeCityPanel() { if (cityWrap) cityWrap.classList.remove('np-list-open'); }

      quickIndices.forEach(function(qСity, index){
        reqAPI({"apiKey": apiKey,"modelName": "AddressGeneral","calledMethod": "searchSettlements","methodProperties": {"CityName" : qСity,"Limit" : "150","Page" : "1"}})
          .then(function(ress) {console.log(ress.data[0].Addresses[0]); dataQuickCity = ress.data[0].Addresses[0]; 
            quickOutput = `<a data-val='`+stripslashes_n(JSON.stringify(dataQuickCity))+`' class='quick-city-link' href='javascript:void(0)' style='display:block; order:`+index+`;'>`+ dataQuickCity.MainDescription + `</a>`;
            document.querySelector('.quick-city-wrap').insertAdjacentHTML('afterbegin',quickOutput);
          })
            .catch();     
      })


      setTimeout( function() {
        document.querySelectorAll('a.quick-city-link').forEach(function(city){
          city.addEventListener("click", function(){  //click


            clearCity.classList.remove('d-none');
            inputWarehouse.readOnly = false;
            document.querySelectorAll(".form-group").forEach(function(el){
              if (!el.classList.contains('form-city')) {              
                el.querySelector('input.form-control').value = '';
                el.querySelector('.clear') ? el.querySelector('.clear').classList.add('d-none') : null;
                if (deliveryType == 'branch')  checkoutButtonWrapper.classList.add('tool');
              }
            })

            cityData = JSON.parse(this.getAttribute('data-val'));          
            addressCity                     = cityData.MainDescription;          
            inputCity.value                 = cityData.Present;
            properties._delivery_city       = cityData.Present;
            properties._delivery_city_Ref   = cityData.DeliveryCity;
            updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(alert);
            clearList(filter);
            filter.classList.remove('active');

              if (deliveryType == 'branch' && cityData.DeliveryCity ) {
                reqAPI({"apiKey": apiKey,"modelName": "AddressGeneral","calledMethod": "getWarehouses","methodProperties": {
          //        "CityName" : cityData.MainDescription,
                  "CityRef" : cityData.DeliveryCity,
                  "Page" : "1",
                  "Limit" : "10000",
                  "Language" : "UA" } 
                })
                  .then(function(res) {console.log(res.data); dataWarehouses = res.data; searchWarehouse(dataWarehouses); })
                    .catch(alert);                  
              } else if (deliveryType == 'courier' && cityData.DeliveryCity) {
                searchStreet(cityData.DeliveryCity);
              } else {
                return;
              }


          })

        })

      }, 1500)

      inputCity.addEventListener("keyup", function(event){   
        console.log('key-'+event.key); 
        if(event.key != 'ArrowLeft' && event.key != 'ArrowRight') {  
          let searchField = this.value;
          inputWarehouse.value = inputStreet.value = '';
          inputWarehouse.readOnly = false;
          document.getElementById('warehouse_filter').classList.remove('active');
          document.getElementById('street_filter').classList.remove('active');
          wrapWarehouse.classList.remove('np-list-open');
          if (deliveryType == 'branch')  checkoutButtonWrapper.classList.add('tool');
          clearCity.classList.remove('d-none');

          if(searchField === '' || searchField === ' ' ){ clearList(filter);filter.classList.remove('active');closeCityPanel();bodyNP.classList.remove('filter-active');cityErrorEl.innerHTML = '';clearCity.classList.add('d-none'); output_prev=0; return;}
          var cityReqId = ++cityReqSeq;

          reqAPI({"apiKey": apiKey,"modelName": "AddressGeneral","calledMethod": "searchSettlements","methodProperties": {
            "CityName" : searchField,
            "Limit" : "150",
            "Page" : "1",
            "Warehouse": "1"
          }
        })
            .then(function(res) {
              /* Only the newest keystroke may touch the list. A slower earlier
                 response must NOT prepend its rows on top of a newer one - that
                 race was the real source of the duplicate "Трускавець" rows. */
              if (cityReqId !== cityReqSeq) return;

              var addresses = (res && res.data && res.data[0] && res.data[0].Addresses) ? res.data[0].Addresses : [];
              dataCities = addresses;

              /* Rebuild from scratch every time so rows can never accumulate
                 across two requests. */
              clearList(filter);

              if (addresses.length === 0) {
                filter.classList.remove('active');
                bodyNP.classList.remove('filter-active');
                closeCityPanel();
                if (output_prev > 0) cityErrorEl.innerHTML = alertCity;
                output_prev = 0;
                return;
              }
              cityErrorEl.innerHTML = '';

              /* Collapse duplicate settlements (NP returns the same one more than
                 once), keeping the record that can actually load branches - i.e.
                 the one with a non-empty DeliveryCity ref and more warehouses. */
              var seen = {}, uniqueCities = [];
              addresses.forEach(function(val){
                var key = val.Present || val.MainDescription || '';
                if (seen[key] === undefined) {
                  seen[key] = uniqueCities.length;
                  uniqueCities.push(val);
                } else {
                  var cur = uniqueCities[seen[key]];
                  var curScore = (cur.DeliveryCity ? 1 : 0) * 1e6 + (Number(cur.Warehouses) || 0);
                  var valScore = (val.DeliveryCity ? 1 : 0) * 1e6 + (Number(val.Warehouses) || 0);
                  if (valScore > curScore) uniqueCities[seen[key]] = val;
                }
              });

              var output = '';
              uniqueCities.forEach(function(val){
                /* In branch mode a settlement with no delivery ref / no
                   warehouses can't produce a branch list - hide it. */
                linkClass = (deliveryType == 'branch' && (val.Warehouses == 0 || !val.DeliveryCity)) ? 'd-none' : '';
                output += `<a data-val='`+stripslashes_n(JSON.stringify(val))+`' class='city-link `+ linkClass +`' href='javascript:void(0)' style='display:block;'>`+ val.Present + `</a>`;
              });

              filter.insertAdjacentHTML('afterbegin', output);
              bodyNP.classList.add('filter-active');
              filter.classList.add('active');
              openCityPanel();
              output_prev = output.length;

              document.querySelectorAll('a.city-link').forEach(function(city){
                city.addEventListener("click", function(){
                  bodyNP.classList.remove('filter-active');
                  document.querySelector('.city-wrap .input-error').innerHTML = "";
                  cityData = JSON.parse(this.getAttribute('data-val'));
                  addressCity                     = cityData.MainDescription;
                  addressCity                     = cityData.Present;//передача повного міста (обл, р-н ...)
                  inputCity.value                 = cityData.Present;
                  properties._delivery_city       = cityData.Present;
                  properties._delivery_city_Ref   = cityData.DeliveryCity;
                  updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(alert);
                  clearList(filter);
                  /* drop the (now empty) city dropdown's active state so the
                     overlay logic targets the warehouse filter, not this stale one */
                  filter.classList.remove('active');
                  closeCityPanel();

                  if (deliveryType == 'branch' && cityData.DeliveryCity ) {
                    reqAPI({"apiKey": apiKey,"modelName": "AddressGeneral","calledMethod": "getWarehouses","methodProperties": {
                      "CityRef" : cityData.DeliveryCity,
          //            "CityName" : cityData.MainDescription,
                      "Page" : "1",
                      "Limit" : "10000",
                      "Language" : "UA"

                    }})
                      .then(function(res) {/*console.log(res.data);*/dataWarehouses = res.data; searchWarehouse(dataWarehouses); })
                        .catch(alert);
                  } else if (deliveryType == 'courier' && cityData.DeliveryCity) {
                    searchStreet(cityData.DeliveryCity);
                  } else {
                    return;
                  }
                });
              });
            })
            .catch( function() {console.log('error');clearList(filter); filter.classList.remove('active'); cityErrorEl.innerHTML = alertKeyboard });
        }
      });
    }
    /*== search branch/postomat  ==*/
    let warehouseBound = false;
    function searchWarehouse(data) {
      wrapWarehouse.classList.remove('d-none');
      let filter = document.querySelector('#warehouse_filter');
      /* Keep the current city's warehouses in the shared variable so the single
         keyup handler below always filters the freshest list. getWarehouses is a
         heavy request (Limit 10000) - previously the keyup listener was attached
         only inside its callback, so the very first keystrokes typed while the
         list was still loading were silently dropped (fetch "didn't happen" until
         the user cleared the input and typed again). */
      dataWarehouses = (data && data.length) ? data : [];

      if (!dataWarehouses.length) {
        checkoutButton.classList.remove('disabled');
        checkoutButtonWrapper.classList.remove('tool');
        checkoutButton.disabled = false;
      }

      /* In the cart drawer the results list becomes a full-screen panel via the
         .np-list-open class. It is normally added asynchronously by
         np-city-dropdown-fix.js, which lets the list paint once in its small
         default position first -> the visible "style jump". Toggle it
         synchronously here, in the same tick the list appears, so there is no
         intermediate frame. Only ever ADDS the final panel look / removes it on
         close - it never hides the list, so it cannot block selection. */
      var isSidebar = (pageType == 'sidebar');
      function openPanel()  { if (isSidebar) wrapWarehouse.classList.add('np-list-open'); }
      function closePanel() { wrapWarehouse.classList.remove('np-list-open'); }

      function renderWarehouse() {
        let searchField = inputWarehouse.value;
        if (searchField === '') {
          clearList(filter);
          filter.classList.remove('active');
          closePanel();
          warehouseErrorEl.innerHTML = '';
          return;
        }
        let list = dataWarehouses || [];
        let safe = searchField.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        let regex = new RegExp(safe, "i"), output = '';

        list.forEach(function(val){
          if ((val.Description.search(regex) != -1)) {
            output += `<a data-val='`+stripslashes_n(JSON.stringify(val))+`' class='warehouse-link' href='javascript:void(0)' style='display:block;'>` + val.Description + `</a>`;
          }
        });
        checkoutButton.classList.add('disabled');
        checkoutButtonWrapper.classList.add('tool');
        checkoutButton.disabled = true;

        clearList(filter);
        if (output.length > 0) {
          warehouseErrorEl.innerHTML = '';
          filter.insertAdjacentHTML('afterbegin', output);
          filter.classList.add('active');
          openPanel();
        } else {
          filter.classList.remove('active');
          closePanel();
          warehouseErrorEl.innerHTML = list.length ? alertWarehouse : '';
        }

        document.querySelectorAll('a.warehouse-link').forEach(function(warehouse){
          warehouse.addEventListener("click", function(el){
            warehouseData = JSON.parse(this.getAttribute('data-val'));
            warehouseErrorEl.innerHTML = '';
            addressStreet = warehouseData.Description;
            inputWarehouse.value = addressStreet;
            inputWarehouse.readOnly = true;
            addressZip = warehouseData.PostalCodeUA;
            addressZip = '12345';
            addressBuild = addressFlat = '';
            clearList(filter);
            filter.classList.remove('active');
            closePanel();
            properties._delivery_warehouse                 = addressStreet;
            properties._delivery_warehouse_zip             = addressZip;
            properties._delivery_warehouse_name            = pointPrefix(warehouseData.CategoryOfWarehouse)+':'+warehouseData.Number;
            properties._delivery_warehouse_address         = warehouseData.ShortAddress;
            properties._delivery_warehouse_CityRef         = warehouseData.CityRef;
            properties._delivery_warehouse_Number          = warehouseData.Number;
            properties._delivery_warehouse_Ref             = warehouseData.Ref;
            properties._delivery_warehouse_SettlementRef   = warehouseData.SettlementRef;
            properties._delivery_warehouse_TypeOfWarehouse = warehouseData.TypeOfWarehouse;

            updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(alert);
            checkoutButton.classList.remove('disabled');
            checkoutButtonWrapper.classList.remove('tool');
            checkoutButton.disabled = false;
            if(pageType == 'sidebar') document.querySelector('.qsc2-side-feature-btn[data-name="shipping"] .qsc2-side-feature-btn__wrapper span').innerHTML = addressCity +', '+pointPrefix(warehouseData.CategoryOfWarehouse)+' '+warehouseData.Number;
          });
        });
      }

      /* If the warehouses arrived AFTER the user already typed, render now so the
         first input is honoured without needing to clear and retype. */
      if (inputWarehouse.value) renderWarehouse();

      /* Attach the keyup listener exactly once - selecting another city just
         refreshes dataWarehouses above, it must not stack duplicate handlers. */
      if (warehouseBound) return;
      warehouseBound = true;

      inputWarehouse.addEventListener("keyup", function(event){
        if (event.key == 'ArrowLeft' || event.key == 'ArrowRight') return;
        clearWarehouse.classList.remove('d-none');
        renderWarehouse();
      });
    }
    /*== search street  ==*/
    function searchStreet(city) {  
      wrapAddresses.classList.remove('d-none');
      dataStreet = false;
      let streetPref;
      let output_prev = 0;
      inputStreet.addEventListener("keyup", function(event){
        if(event.key != 'ArrowLeft' && event.key != 'ArrowRight') {
          clearStreet.classList.remove('d-none');
          var filter = document.querySelector('#street_filter');  
          var searchField = this.value;
          if(searchField === '' || searchField.includes('&#8291;') || searchField === ' ')  {
            clearList(filter); clearStreet.classList.add('d-none'); streetErrorEl.innerHTML = ''; return;
          }
          if(searchField.includes(streetPref))  {          
            this.value = searchField.split(streetPref)[1];
          }  
        
          
          reqAPI({"apiKey": apiKey,"modelName": "AddressGeneral","calledMethod": "getStreet","methodProperties": {"CityRef" : city,"FindByString" : this.value,"Page" : "1","Limit" : "150"}})
            .then(function(res) {/*console.log(res.data);*/dataStreet = res.data;})
              .catch(function() {clearList(filter); streetErrorEl.innerHTML = alertKeyboard }); 
          
          var output = '';
          var count = 1;
            
          setTimeout( function() {
            dataStreet.forEach(function(val){ 		  
                output += '<a data-ref="'+val.Ref+'" data-street="'+ val.StreetsType + val.Description +'" data-prefix="'+val.StreetsType+'" class="street-link" href="javascript:void(0)" style="display:block;">' + val.StreetsType + val.Description + '</a>';
                count++;
            });

            if(dataStreet.length > 0 ) {clearList(filter); streetErrorEl.innerHTML = '';} else { if(output_prev > 0) streetErrorEl.innerHTML = alertStreet};
            filter.insertAdjacentHTML('afterbegin',output);

            let streetLinks = document.querySelectorAll('a.street-link');
            if(streetLinks.length > 0) {
              document.getElementById('street_filter').classList.add('active');
            }   
            streetLinks.forEach(function(street){
              street.addEventListener("click", function(el){
                addressStreet = this.getAttribute('data-street');
                inputStreet.value=this.getAttribute('data-street');
                streetPref = this.getAttribute('data-prefix');
                addressZip ='12345';
                clearList(filter);
                properties._delivery_courier_address    = addressStreet;
                properties._delivery_street             = addressStreet;
                properties._delivery_street_Ref         = this.getAttribute('data-ref');

              updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(alert);

                checkoutButton.classList.remove('disabled');
                checkoutButtonWrapper.classList.remove('tool');
                checkoutButton.disabled = false;
                return;
              });
            })
          output_prev = output.length ;        
          },500);
        }
      });

      inputStreet.addEventListener("focusout", function(){
        if(this.value || this.value != '') {
          addressStreet = 'вул.'+this.value;
          properties._delivery_courier_address  = addressStreet;
          properties._delivery_street           = addressStreet;
          updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(alert);
        }
      })      
    }
    /*== input build  ==*/
    inputBuild.addEventListener("keyup", function(){
      addressBuild = ', буд.'+this.value;
    })
    inputBuild.addEventListener("focusout", function(){
      addressStreet = addressStreet+''+addressBuild;
      properties._delivery_courier_address = addressStreet;
      properties._delivery_house           = addressBuild;
      updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(alert);
    });
    /*== input flat  ==*/
    inputFlat.addEventListener("keyup", function(){
      addressFlat = ', кв.'+this.value;
    })
    inputFlat.addEventListener("focusout", function(){
      addressStreet = addressStreet+''+addressFlat;
      properties._delivery_courier_address = addressStreet;
      properties._delivery_flat            = addressFlat;
    updateCartDeliveryAttr(properties).then(function(cart) {/*console.log(cart)*/}).catch(alert);
    });
    function addErrorMessage() {
      const errorContainer = document.querySelector('.cart-terms .alert-danger');
        
        if (!errorContainer) return false;
      
        if (errorContainer && !(errorContainer.getAttribute('added-text'))) {
            errorContainer.innerHTML += ` ${translations?.shipping_method?.title}`;
        
          errorContainer.setAttribute('added-text', 'true');
          
          return true;
        }
    }
    const errorInterval = setInterval(() => {
      const isSet = addErrorMessage();

      if (isSet !== false) clearInterval(errorInterval);
    }, 100);  
    checkoutButton.addEventListener('click', async function(e) {
//alert('click');
      let shouldDisable = true;	
      if (shouldDisable) this.classList.add('disabled');
      
      e.preventDefault();
      this.disabled = true;
      /* INTL: своя валідація і свій permalink, українська логіка нижче не потрібна */
      if (deliveryType == 'intl') {
        if (!intlValid()) {
          intlShowErrors();
          this.disabled = false;
          this.classList.remove('disabled');
          return;
        }
        intlCheckout();
        return;
      }     

      addressStreet = (addressStreet)?addressStreet:'';
      addressCity = (addressCity)?addressCity:'';
      addressCity = properties._delivery_city;
      addressZip = '12345';
        const address = ({
          /* В адрес доставки идёт ПОЛНОЕ название отделения из API
             (warehouseData.Description, оно же properties._delivery_warehouse и
             оно же то, что покупатель видел в списке), например:
             «Відділення №30 (до 30 кг на одне місце): вул. Привокзальна, 12».
             Раньше собиралась короткая строка pointPrefix()+' '+Number →
             «Відділення 30», по которой курьер/менеджер не находит точку. */
          address1: (deliveryType == 'branch')
            ? (properties._delivery_warehouse
               || inputWarehouse.value
               || pointPrefix(warehouseData.CategoryOfWarehouse)+' '+warehouseData.Number)
            : addressStreet+' ('+methodCourier+')',
          zip: addressZip, 
          city: addressCity,
          country: country
        });
      setTimeout( function() {
      fetch(`${cartUrl}.json`).then(response => response.json()).then(data => {
          const pairs = [];
          
          const path = data.items.map(item => {
            return `${item.variant_id}:${item.quantity}`;
          }).join(',');

          orderAttrPairs(properties).forEach(function (pair) { pairs.push(pair); });

          for (var key in address) {
            const value = address[key];

            if (!value) continue;

            const pair = `checkout[shipping_address][${key}]=${address[key]}`;

            pairs.push(pair);
          }

          let query;
          let url;
          if (data.note && data.note != null) {
          query = pairs.join('&') + `&note=${data.note}`;
          url = `${cartUrl}/${path}?${query}`;
          } else {
          query = pairs.join('&');  
          url = `${cartUrl}/${path}?${query}`;
          }
        //alert('checkout-url: ' + url);
          goToCheckout(url);

        })
        
      
      
      },200); 
        
    });
    searchCity();
  } else {
    errorAPI();
  }
})
.catch(err => {  
  errorAPI();  
})

}